import type {EntityIdentifierEnum, ModuleEnum} from 'src/api/ProactApiClient';
import {ModuleExtensionRegistry} from 'src/shared/constants/moduleExtensionRegistry';

export const ModuleEntityTypeMap: Partial<
  Record<ModuleEnum, EntityIdentifierEnum>
> = Object.fromEntries(
  Object.entries(ModuleExtensionRegistry).map(([module, config]) => [
    module,
    config.entityType,
  ])
) as Partial<Record<ModuleEnum, EntityIdentifierEnum>>;
